import styled from 'styled-components';
import { boxStyles, shouldForwardProp } from "./box-styles";
export var Box = styled('div').withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Box",
  componentId: "vapor__sc-1omy478-0"
})(["", ""], boxStyles);